import { createFileRoute } from "@tanstack/react-router";
import { PaginaRota } from "@/paginas/estoque";

export const Route = createFileRoute("/_authenticated/estoque")({
  head: () => ({
    meta: [
      { title: "Estoque — Milky Moo Palmares" },
      {
        name: "description",
        content: "Posição dos estoques, compras, transferências, perdas e validade.",
      },
      { property: "og:title", content: "Estoque — Milky Moo Palmares" },
      {
        property: "og:description",
        content: "Posição dos estoques, compras, transferências, perdas e validade.",
      },
    ],
  }),
  component: PaginaRota,
});
